import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Spinner } from '~ui-kit';
import Summary from '../forms/formik/components/Summary';
import {
  ScrollToTopOnMount,
  getFormCustomContentByFormType,
} from '~utils/common.utils';

// Routes
// Lazy load large, rarely used features

import CallSystemForm from '../forms/callSystem';
import PhonePlanForm from '../forms/phonePlan';
import TransportsForm from '../forms/patientsTransports';
import SpaceMaintenance from '../forms/spaceMaintenance';
import GasBottles from '../forms/gasBottles';
import TrashCansForm from '../forms/trashCans';
import ApplianceMaintenance from '../forms/applianceMaintenance';
import GoodsTransports from '../forms/goodsTransports';
import ICTTrouble from '../forms/ICTServices/trouble';
import Instruments from '../forms/instruments';
import InfoRequest from '../forms/infoRequest';
import ICTLinks from '../forms/ICTLinks';
import GenericSupport from '../forms/genericSupport';
import Cleaning from '../forms/cleaning';
import ClothingMaintenance from '../forms/clothingMaintenance';
import TagActivation from '../forms/tagActivation';
import Tags from '../forms/tags';
import DeceasedTransports from '../forms/deceasedTransports';
import GroupEmails from '../forms/groupEmails';
import Wardrobe from '../forms/wardrobe';
import BedClean from '../forms/bedClean';
import OperatingRoomClean from '../forms/operatingRoomClean';
import StudyRoomClean from '../forms/studyRoomClean';
import Snack from '../forms/snack';
import DeviceLinks from '../forms/deviceLinks';
import SpaceRequest from '../forms/spaceRequest';
import WorkstationLinks from '../forms/workstationLinks';
// import Webshop from '~features/webshop';
// import Beds from '~features/beds';
const ProjectsView = lazy(() => import('./projects/ProjectsView'));

// const CallSystemForm = lazy(() => import('~features/appliances/callsystem'));
// const PhonePlanForm = lazy(() => import('~features/appliances/phoneplans'));
// const TransportsForm = lazy(() => import('../forms/patientsTransports'));
// const MaintenanceForm = lazy(() => import('../forms/maintenance'));
// const GasBottles = lazy(() => import('../forms/gasBottles'));
// const TrashCansForm = lazy(() => import('../forms/trashCans'));
// const ApplianceMaintenanceForm = lazy(() =>
//   import('../forms/applianceMaintenance')
// );
// const GoodsTransports = lazy(() => import('../forms/goodsTransports'));
// const ICTServices = lazy(() => import('../forms/ICTServices'));
// const Instruments = lazy(() => import('../forms/instruments'));
const Webshop = lazy(() => import('~features/webshop'));
const Beds = lazy(() => import('~features/beds'));

// List of known routes
// paths correspond to customContent defined in the management app
// so if you add a new form, make sure to add it there as well
const routes = [
  {
    formType: 'PROJECTS',
    path: 'projektit',
    editable: false,
    component: ProjectsView,
  },
  {
    formType: 'BEDS',
    path: 'sairaansijat',
    editable: false,
    component: Beds,
  },
  {
    formType: 'CUSTOM_FORM_PRODUCTS',
    path: 'tuotteet',
    editable: false,
    component: Webshop,
  },
  {
    formType: 'CUSTOM_FORM_APPLIANCES',
    path: getFormCustomContentByFormType('CUSTOM_FORM_APPLIANCES'),
    title: 'Tilaa laitehuolto',
    editable: true,
    component: ApplianceMaintenance,
  },
  {
    formType: 'CUSTOM_FORM_EXTENSIONS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_EXTENSIONS'),
    editable: true,
    component: PhonePlanForm,
  },
  {
    formType: 'CUSTOM_FORM_SONDS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_SONDS'),
    editable: true,
    component: CallSystemForm,
  },
  {
    formType: 'CUSTOM_FORM_INTERNALPATIENTTRANSPORT',
    path: getFormCustomContentByFormType(
      'CUSTOM_FORM_INTERNALPATIENTTRANSPORT'
    ),
    editable: true,
    returnable: true,
    component: TransportsForm,
  },
  {
    formType: 'CUSTOM_FORM_SPACEREPAIRS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_SPACEREPAIRS'),
    editable: false,
    component: SpaceMaintenance,
  },
  {
    formType: 'CUSTOM_FORM_GASBOTTLES',
    path: getFormCustomContentByFormType('CUSTOM_FORM_GASBOTTLES'),
    editable: false,
    component: GasBottles,
  },
  {
    formType: 'CUSTOM_FORM_INSTRUMENT_SERVICE',
    path: getFormCustomContentByFormType('CUSTOM_FORM_INSTRUMENT_SERVICE'),
    editable: false,
    component: Instruments,
  },
  {
    formType: 'CUSTOM_FORM_INTERNALPACKETTRANSPORT',
    path: getFormCustomContentByFormType('CUSTOM_FORM_INTERNALPACKETTRANSPORT'),
    editable: false,
    component: GoodsTransports,
  },
  {
    formType: 'CUSTOM_FORM_IT_SUPPORT_TICKETS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_IT_SUPPORT_TICKETS'),
    editable: false,
    component: ICTTrouble,
  },
  {
    formType: 'CUSTOM_FORM_WASTETRANSPORT',
    path: getFormCustomContentByFormType('CUSTOM_FORM_WASTETRANSPORT'),
    title: 'Jäteastian tyhjennys',
    editable: false,
    component: TrashCansForm,
  },
  {
    formType: 'CUSTOM_FORM_INFO_REQUEST_TICKETS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_INFO_REQUEST_TICKETS'),
    editable: false,
    component: InfoRequest,
  },
  {
    formType: 'CUSTOM_FORM_IT_SERVICE_LINKS',
    path: getFormCustomContentByFormType('CUSTOM_FORM_IT_SERVICE_LINKS'),
    editable: false,
    component: ICTLinks,
  },
  {
    formType: 'CUSTOM_FORM_GENERIC_SUPPORT',
    path: getFormCustomContentByFormType('CUSTOM_FORM_GENERIC_SUPPORT'),
    editable: false,
    component: GenericSupport,
  },
  {
    formType: 'CUSTOM_FORM_CLEANING',
    path: getFormCustomContentByFormType('CUSTOM_FORM_CLEANING'),
    editable: false,
    component: Cleaning,
  },
  {
    formType: 'CUSTOM_FORM_CLOTHING_MAINTENANCE',
    path: getFormCustomContentByFormType('CUSTOM_FORM_CLOTHING_MAINTENANCE'),
    editable: false,
    component: ClothingMaintenance,
  },
  {
    formType: 'CUSTOM_FORM_ACCESS_TAG_ORDER',
    path: getFormCustomContentByFormType('CUSTOM_FORM_ACCESS_TAG_ORDER'),
    editable: false,
    component: Tags,
  },
  {
    formType: 'CUSTOM_FORM_ACCESS_TAG_ACTIVATION',
    path: getFormCustomContentByFormType('CUSTOM_FORM_ACCESS_TAG_ACTIVATION'),
    editable: false,
    component: TagActivation,
  },
  {
    formType: 'CUSTOM_FORM_DECEASED_TRANSPORT',
    path: getFormCustomContentByFormType('CUSTOM_FORM_DECEASED_TRANSPORT'),
    editable: false,
    component: DeceasedTransports,
  },
  {
    formType: 'CUSTOM_FORM_EMAIL_GROUP_REQUEST',
    path: getFormCustomContentByFormType('CUSTOM_FORM_EMAIL_GROUP_REQUEST'),
    editable: false,
    component: GroupEmails,
  },
  {
    formType: 'CUSTOM_FORM_WARDROBE_REQUEST',
    path: getFormCustomContentByFormType('CUSTOM_FORM_WARDROBE_REQUEST'),
    editable: false,
    component: Wardrobe,
  },
  {
    formType: 'CUSTOM_FORM_BED_CLEAN',
    path: getFormCustomContentByFormType('CUSTOM_FORM_BED_CLEAN'),
    editable: true,
    component: BedClean,
  },
  {
    formType: 'CUSTOM_FORM_OPERATING_ROOM_CLEAN',
    path: getFormCustomContentByFormType('CUSTOM_FORM_OPERATING_ROOM_CLEAN'),
    editable: true,
    component: OperatingRoomClean,
  },
  {
    formType: 'CUSTOM_FORM_EXAMINATION_ROOM_CLEAN',
    path: getFormCustomContentByFormType('CUSTOM_FORM_EXAMINATION_ROOM_CLEAN'),
    editable: true,
    component: StudyRoomClean,
  },
  {
    formType: 'CUSTOM_FORM_SNACK',
    path: getFormCustomContentByFormType('CUSTOM_FORM_SNACK'),
    editable: true,
    component: Snack,
  },
  {
    formType: 'CUSTOM_FORM_DEVICE_LINKS',
    path: 'laitelinkit',
    editable: false,
    component: DeviceLinks,
  },
  {
    formType: 'CUSTOM_FORM_SPACEREQUEST',
    path: 'tilapyynnot',
    editable: false,
    component: SpaceRequest,
  },
  {
    formType: 'CUSTOM_FORM_WORKSTATION_LINKS',
    path: 'tyoasemalinkit',
    editable: false,
    component: WorkstationLinks,
  },
];

const ServiceContainer = props => {
  const getFlatNav = () => {
    const children = Object.values(props.navItems).map(
      category => category.children
    );

    return _.flatten(children);
  };

  const { navItems } = props;

  if (!navItems.length) {
    return <ServiceContainerEl>Ladataan...</ServiceContainerEl>;
  }

  const flatNav = getFlatNav();

  // Add form ids to each route (except PhonePlanForm because it's not in nav)
  // Some forms need their form ids to fetch a specific list of units
  routes.forEach((routeForm, i) => {
    const navForm = flatNav.find(form => form.customContent === routeForm.path);
    if (navForm) routes[i].formId = navForm.formId;
  });

  return (
    <ServiceContainerEl>
      <Suspense fallback={<Spinner />}>
        <Routes>
          {routes.map(route => {
            const Component = route.component;

            const variants = [];

            // Add edit route for certain forms
            if (route.editable) {
              variants.push(
                <Route
                  key={`${route.path}-edit`}
                  path={`/${route.path}/muokkaa/:orderId`}
                  element={
                    <>
                      <ScrollToTopOnMount />
                      <Component formId={route.formId} edit />
                    </>
                  }
                />
              );
            }

            // Add return route for certain forms
            if (route.returnable) {
              variants.push(
                <Route
                  key={`${route.path}-returnOrder`}
                  path={`/${route.path}/paluukuljetus/:orderId`}
                  element={
                    <>
                      <ScrollToTopOnMount />
                      <Component {...props} formId={route.formId} returnOrder />
                    </>
                  }
                />
              );
            }

            // Order is done route
            variants.push(
              <Route
                key={route.path}
                path={`/${route.path}/valmis/:id`}
                element={
                  <>
                    <ScrollToTopOnMount />
                    <Summary
                      title={route.title || route.path}
                      path={route.path}
                    />
                  </>
                }
              />
            );

            // Actual route to form
            variants.push(
              <Route
                key={route.path}
                exact={false}
                path={`/${route.path}/*`}
                element={
                  <>
                    <ScrollToTopOnMount />
                    <Component formId={route.formId} />
                  </>
                }
              />
            );

            return variants;
          })}
        </Routes>
      </Suspense>
    </ServiceContainerEl>
  );
};

const ServiceContainerEl = styled.div`
  /* min-height: 500px;
  padding: 16px 0px; */
`;

const mapStateToProps = state => ({
  navItems: state.reducer.navlist,
});

export default connect(mapStateToProps)(ServiceContainer);
